import ImageBreak from '@rsa-digital/evo-shared-components/components/ImageBreak';
import { graphql } from 'gatsby';
import React from 'react';
import { processImageAsset } from 'helpers/csTypeProcessors';
import { CsAsset } from 'types/contentStack';

type ImageBreakBlockProps = {
  image_break: {
    image_break: CsAsset;
  };
};

export const query = graphql`
  fragment ImageBreakBlock on cs__image_break {
    image_break {
      ...Asset
    }
  }
`;

const ImageBreakBlock: React.FC<ImageBreakBlockProps> = ({ image_break }) => {
  const image = processImageAsset(image_break.image_break);

  /* istanbul ignore if */
  if (!image) {
    throw new Error('Image missing for Image Break!');
  }

  return <ImageBreak image={image} data-cy="ImageBreak" />;
};

export default React.memo(ImageBreakBlock);
